// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gcdW5","title":"styles_title__eHPz0","terms":"styles_terms__JNmAA"};